import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

// Components
import { FullTabMenuCard } from '../../components/component-items/tab-menu'
import { Col, Row } from 'react-bootstrap'

// Cards
import { NotificationList } from '../../components/notifications/'
import { NotificationTags } from './tags'
import { Changelog } from './changelog'
import { TabProps } from './types'

// Fontawesome
import { faBell, faHashtag, faStream } from '@fortawesome/pro-duotone-svg-icons'

export const NotificationPage = () => {
  const location = useLocation()
  const tabMapping: TabProps[] = [
    {
      label: 'Activity Feed',
      hash: 'activity',
      component: <NotificationList type="user" title="User Activity" />,
      icon: faBell,
    },
    {
      label: 'Changelog',
      hash: 'changelog',
      component: <Changelog />,
      icon: faStream,
    },
    {
      label: 'Tags',
      hash: 'tags',
      component: <NotificationTags />,
      icon: faHashtag,
    },
  ]
  const tabOptions = tabMapping.map((tab) => tab.label)
  const [activeTab, setActiveTab] = useState(tabOptions[0])

  const changeActiveTab = (tabLabel: string) => {
    const tab = tabMapping.find((t) => t.label === tabLabel)
    if (tab) {
      history.pushState(null, '', `#${tab.hash}`)
      setActiveTab(tab.label)
    }
  }

  useEffect(() => {
    const hash = location.hash.replace('#', '')
    const hashKey = hash.split('=')[0]
    const tab = tabMapping.find((tab) => tab.hash === hashKey)
    if (tab) {
      setActiveTab(tab.label)
    }
  }, [location.hash])

  return (
    <FullTabMenuCard {...{ tabMapping, activeTab }} setActiveTab={changeActiveTab}>
      <div style={{ minHeight: 500 }}>{tabMapping.find((tab) => tab.label === activeTab)?.component}</div>
    </FullTabMenuCard>
  )
}
